import axios from "axios";

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_APIBASE,
  auth: {
    username: process.env.REACT_APP_AUTH_USERNAME,
    password: process.env.REACT_APP_AUTH_PASSWORD,
  },
});

export const s_post = async (url, data, header = {}) => {
  return await axiosApi
    .post(url, data, {
      headers: {
        user_token: JSON.parse(localStorage.getItem("authUser"))?.user_token
          ? JSON.parse(localStorage.getItem("authUser"))?.user_token
          : localStorage.getItem("uid")
          ? JSON.parse(localStorage.getItem("uid"))
          : "",
        ...header,
      },
    })
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = "Bad request";
            break;
        }
      }
      throw message;
    });
};

export async function s_get(url) {
  return await axiosApi
    .get(url, {
      headers: {
        user_token: JSON.parse(localStorage.getItem("authUser"))?.user_token
          ? JSON.parse(localStorage.getItem("authUser"))?.user_token
          : localStorage.getItem("uid")
          ? JSON.parse(localStorage.getItem("uid"))
          : "",
      },
    })
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      // console.log(err)
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Unauthorized";
            break;
          default:
            message = "Bad request";
            break;
        }
      }
      throw message;
    });
}
